<div class="main">
  <div class="d-flex">
    <p class="name mg-bottom-32">Confira as informações</p>
  </div>

  <div [class]="isMobile ? '' : 'mg-bottom-16'" class="row">
    <div class="col-md-4">
      <span class="order-label">Nome do pagador</span><br />
      <span class="order-value">{{ orderDetails?.nameSender }}</span>
    </div>
    <div class="col-md-4">
      <span class="order-label">País do pagador</span><br />
      <span class="order-value">{{ orderCountry?.description }}</span>
    </div>
    <div class="col-md-4">
      <span class="order-label">E-mail do pagador</span><br />
      <span class="order-value">{{ orderDetails?.emailSender }}</span>
    </div>
  </div>

  <div class="row mg-bottom-16">
    <div class="col-md-4">
      <span class="order-label">Valor a receber</span><br />
      <span class="order-value"
        >{{ orderDetails?.currencyDescription }}
        {{ orderDetails?.amount }}</span
      >
    </div>
    <div class="col-md-4">
      <span class="order-label">Moeda a receber</span><br />
      <span class="order-value">{{ orderCurrency?.description }}</span>
    </div>
  </div>

  <div class="d-flex justify-content-between">
    <p class="name">
      Canal bancário para informar no exterior para recebimento
    </p>
    <img
      *ngIf="companyId"
      (click)="copyText()"
      class="tappable"
      src="assets/icons/copy-bank.svg"
    />

    <img
      *ngIf="!companyId"
      (click)="copyText()"
      class="tappable"
      src="assets/icons/copy-bank-pf.svg"
    />
  </div>

  <div class="row">
    <div class="bank-account">
      <div class="section-bank">
        <div class="row">
          <span>
            <span class="label">Intermediary Bank: </span>
            <span class="value">{{
              currencyDetails?.intermediaryBankChannels[0]?.bank
            }}</span>
          </span>
        </div>
        <div class="row">
          <span>
            <span class="label">Swift Code: </span>
            <span class="value">{{
              currencyDetails?.intermediaryBankChannels[0]?.swift
            }}</span>
          </span>
        </div>
        <div class="row">
          <span>
            <span class="label">Account: </span>
            <span class="value">{{
              currencyDetails?.intermediaryBankChannels[0]?.account
            }}</span>
          </span>
        </div>
        <div class="row">
          <span>
            <span class="label">Address: </span>
            <span class="value">{{
              currencyDetails?.intermediaryBankChannels[0]?.address
            }}</span>
          </span>
        </div>
      </div>

      <div class="section-bank">
        <div class="row">
          <span>
            <span class="label">Beneficiary Bank: </span>
            <span class="value">{{
              currencyDetails?.beneficiaryBankChannels[0]?.bank
            }}</span>
          </span>
        </div>
        <div class="row">
          <span>
            <span class="label">Swift Code: </span>
            <span class="value">{{
              currencyDetails?.beneficiaryBankChannels[0]?.swift
            }}</span>
          </span>
        </div>
        <div class="row">
          <span>
            <span class="label">Address: </span>
            <span class="value">{{
              currencyDetails?.beneficiaryBankChannels[0]?.address
            }}</span>
          </span>
        </div>
      </div>

      <div>
        <div class="row">
          <p class="name pt-1">Beneficiary</p>
        </div>
        <div class="row">
          <span>
            <span class="label">Account: </span>
            <span class="value"
              >{{ currencyDetails?.beneficiaries[0]?.account }}
              {{ currencyDetails?.beneficiaries[0]?.nomecliente }}</span
            >
          </span>
        </div>
        <div class="row">
          <span>
            <span class="label">Reference: </span>
            <span class="value">{{
              currencyDetails?.beneficiaries[0]?.reference
            }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="spacer"></div>

  <div class="buttons border-grey-light">
    <div class="cols d-flex">
      <button
        (click)="close()"
        type="button"
        class="btn btn-block btn-dark-primary-outline-back"
        type="button"
      >
        Cancelar
      </button>
    </div>
    <div class="cols d-flex">
      <button
        (click)="back()"
        type="button"
        [class]="isMobile ? 'd-none' : ''"
        class="btn btn-block btn-dark-primary-outline-back"
        type="button"
      >
        Voltar
      </button>

      <button
        (click)="createOrder()"
        type="submit"
        [disabled]="loading"
        class="btn w-200 mt-0 ml-3"
        [ngClass]="
          companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
        "
        type="button"
      >
        {{ isMobile ? "Gerar ordem" : "Gerar ordem de recebimento" }}
        <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
      </button>
    </div>
  </div>
</div>
